import { fromJS } from 'immutable'
import { createReducer } from 'redux-immutablejs'

import {
  EssentialsEventData,
  EssentialsRegisteredEventData,
} from '@lyrahealth-inc/shared-app-logic/src/features/essentials/types'

import {
  FETCH_ESSENTIALS_EVENTS_BY_TAGS_fulfilled,
  FETCH_ESSENTIALS_EVENTS_BY_TAGS_pending,
  FETCH_ESSENTIALS_EVENTS_BY_TAGS_rejected,
  FETCH_ESSENTIALS_EVENTS_FULL_LIST_fulfilled,
  FETCH_ESSENTIALS_EVENTS_FULL_LIST_pending,
  FETCH_ESSENTIALS_EVENTS_FULL_LIST_rejected,
  GET_REGISTERED_ESSENTIALS_EVENTS_FOR_USER_fulfilled,
  GET_REGISTERED_ESSENTIALS_EVENTS_FOR_USER_pending,
  GET_REGISTERED_ESSENTIALS_EVENTS_FOR_USER_rejected,
  SET_SHOULD_GO_FULLSCREEN_FOR_MIXES,
} from './essentialsActions'

type LoadingState = 'idle' | 'pending' | 'fulfilled' | 'rejected'

interface EssentialsState extends Map<string, any> {
  registeredEventsForUser: EssentialsRegisteredEventData[] | null
  essentialsEventsFullList: EssentialsEventData[] | null
  essentialsEventsByTags: EssentialsEventData[] | null
  shouldGoFullscreenForMixes: boolean
  // Loading states
  registeredEventsForUserLoading: LoadingState
  essentialsEventsByTagsLoading: LoadingState
  essentialsEventsFullListLoading: LoadingState
}

const initialState: EssentialsState = fromJS({
  registeredEventsForUser: null,
  essentialsEventsFullList: null,
  essentialsEventsByTags: null,
  shouldGoFullscreenForMixes: false,
  // Loading states
  registeredEventsForUserLoading: 'idle',
  essentialsEventsByTagsLoading: 'idle',
  essentialsEventsFullListLoading: 'idle',
})

export default createReducer(initialState, {
  [GET_REGISTERED_ESSENTIALS_EVENTS_FOR_USER_pending]: ($$state: EssentialsState) => {
    return $$state.set('registeredEventsForUserLoading', 'pending')
  },
  [GET_REGISTERED_ESSENTIALS_EVENTS_FOR_USER_fulfilled]: (
    $$state: EssentialsState,
    action: { payload: EssentialsRegisteredEventData[] },
  ) => {
    return $$state.set('registeredEventsForUser', action?.payload).set('registeredEventsForUserLoading', 'fulfilled')
  },
  [GET_REGISTERED_ESSENTIALS_EVENTS_FOR_USER_rejected]: ($$state: EssentialsState) => {
    return $$state.set('registeredEventsForUserLoading', 'rejected')
  },
  [FETCH_ESSENTIALS_EVENTS_FULL_LIST_pending]: ($$state: EssentialsState) => {
    return $$state.set('essentialsEventsFullListLoading', 'pending')
  },
  [FETCH_ESSENTIALS_EVENTS_FULL_LIST_fulfilled]: (
    $$state: EssentialsState,
    action: { payload: EssentialsEventData[] },
  ) => {
    return $$state.set('essentialsEventsFullList', action?.payload).set('essentialsEventsFullListLoading', 'fulfilled')
  },
  [FETCH_ESSENTIALS_EVENTS_FULL_LIST_rejected]: ($$state: EssentialsState) => {
    return $$state.set('essentialsEventsFullListLoading', 'rejected')
  },
  [FETCH_ESSENTIALS_EVENTS_BY_TAGS_pending]: ($$state: EssentialsState) => {
    return $$state.set('essentialsEventsByTagsLoading', 'pending')
  },
  [FETCH_ESSENTIALS_EVENTS_BY_TAGS_fulfilled]: (
    $$state: EssentialsState,
    action: { payload: EssentialsEventData[] },
  ) => {
    return $$state.set('essentialsEventsByTags', action?.payload).set('essentialsEventsByTagsLoading', 'fulfilled')
  },
  [FETCH_ESSENTIALS_EVENTS_BY_TAGS_rejected]: ($$state: EssentialsState) => {
    return $$state.set('essentialsEventsByTagsLoading', 'rejected')
  },
  [SET_SHOULD_GO_FULLSCREEN_FOR_MIXES]: ($$state: EssentialsState, action: { value: boolean }) => {
    return $$state.set('shouldGoFullscreenForMixes', action.value)
  },
})
